/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled.ts";

function getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledUrl(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/parcels/open-cancelled` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/OpenCancelParcels. **(Requer Authorization para autenticação)**
 * @summary Reabre parcelas canceladas do plano como pendentes (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels/open-cancelled}
 */
export async function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"],
  data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
    >,
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledUrl(
      financialPersonId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
